import axios from 'axios';
import { pushError } from '../stores/notificationStore';

const API_URL = '/JSONRPC';

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add session header to every request
apiClient.interceptors.request.use((config) => {
  const sid = localStorage.getItem('brit_sid');
  if (sid) {
    config.headers['BRIT-Session'] = sid;
  }
  return config;
});

// Handle session expiry (403) — redirect to login
apiClient.interceptors.response.use(
  (response) => {
    // JSON-RPC errors come back as 200 with error in body
    if (response.data?.error) {
      const code = response.data.error.code;
      if (code === 403) {
        localStorage.removeItem('brit_sid');
        window.location.href = '/login';
      }
      // Non-auth errors are NOT toasted here — rpcCall() re-checks
      // response.data.error and throws, so caller .catch() handles display.
      // Toasting here would cause double-toast for every RPC error.
    }
    return response;
  },
  (error) => {
    // Silently ignore cancelled/aborted requests (e.g. React StrictMode remounts)
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    // HTTP-level 401/403
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('brit_sid');
      window.location.href = '/login';
    } else {
      // Network or other HTTP errors — push notification
      const msg = error.response?.data?.message || error.message || 'Network error';
      pushError(msg);
    }
    return Promise.reject(error);
  },
);
